import { sendWebSlsTrackingData } from '@/utils/slsTracking';

export default {
  // 初始化指令
  bind(el, binding, vnode) {
    // eslint-disable-next-line consistent-return
    function clickHandler(e) {
      e.stopPropagation();
      const { expression } = binding;
      // 这里判断点击的元素是否是本身
      if (el.contains(e.target) && el.attributes?.trackCode?.value) {
        sendWebSlsTrackingData({
          name: el.attributes?.trackingName?.value || '',
          code: el.attributes.trackCode.value,
          params: expression ? vnode.context[expression] : '',
        });
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueTrackClick__ = clickHandler;
    el.addEventListener('click', clickHandler);
  },
  unbind(el) {
    if (el) {
      // 解除事件监听
      el.removeEventListener('click', el.__vueTrackClick__);
      delete el.__vueTrackClick__;
    }
  },
};
